import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import { useContext, useEffect, useRef, useState } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { Button } from "primereact/button";
import { AppDB } from "../../App";
import { helper } from "../../componets/utils/helper";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import VotersService from "../../services/VotersService";
import { formatDate, formatDateTime, maskMiddle } from "../../config/Config";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog"; // For <ConfirmDialog /> component
import { Dropdown } from "primereact/dropdown";
import { changeLang } from "../../componets/Language/ChangeLang";
import GenericDataTable from "../../componets/GenericDataTable";
import MultiFilterSearch from "../../componets/MultiFilterSearch";

export default function RegistredAndNonRegistered({ header, isDialog = true }) {


	var { selectedParty, isIecEdit, isOnlyView, contestationPeriodID } = useContext(PoliticalPartyDBContext);
	var political = new PoliticalPartyService();
	var [registerdMembers, setRegisterdMembers] = useState([]);
	var [nonRegisterdMembers, setNonRegisterdMembers] = useState([]);
	const inputFileRef = useRef(null);
	var [loading, setLoading] = useState(false);

	var [refresh, setRefresh] = useState(false);
	var [showAddDialog, setShowAddDialog] = useState({ show: false, voterRecord: null, idNumber: "" });
	var { toast } = useContext(AppDB);

	var political = new PoliticalPartyService();
	var voter = new VotersService();

	async function getRegisteredMembers(page) {
		if (contestationPeriodID !== null) {
			setLoading(true);
			var res = await political.getRegisteredMembersByParty(selectedParty.politicalPartyID, contestationPeriodID, page);
			setRegisterdMembers(res.members);
			setLoading(false);
			return res;
		}
	}

	async function getnonRegisteredMembers(page) {
		if (contestationPeriodID !== null) {
			setLoading(true);
			var res = await political.getNotRegisteredMembersByParty(selectedParty.politicalPartyID, contestationPeriodID, page);
			setNonRegisterdMembers(res.records);
			setLoading(false);
			return res;
		}
	}

	function searchVoterByIDNumber() {
		setLoading(true);
		voter.searchVoter(showAddDialog.idNumber).then((res) => {
			setLoading(false);
			console.log(res);
			var status = `${res}`;
			if (status.trim().length === 0) {
				toast.show({
					severity: "error",
					detail: "Elector not Found",
					life: 2500
				});
			} else {
				setShowAddDialog({
					...showAddDialog,
					voterRecord: {
						firstname: res.firstname,
						surname: res.surname,
						dateOfBirth: res.dateOfBirth,
						gender: res.gender,
						voterID: res.voterID
					}
				});
			}
		});
	}
	function searchVoterByIDNumberFilter(idNumber) {
		setLoading(true);
		voter.searchVoter(idNumber).then((res) => {
			setLoading(false);
			console.log(res);
			var status = `${res}`;
			if (status.trim().length === 0) {
				toast.show({
					severity: "error",
					detail: "Elector not Found",
					life: 2500
				});
			} else {
				setShowAddDialog({
					...showAddDialog,
					voterRecord: {
						firstname: res.firstname,
						surname: res.surname,
						dateOfBirth: res.dateOfBirth,
						gender: res.gender,
						voterID: res.voterID
					}
				});
			}
		});
	}

	const handleFileUpload = async (event) => {
		setLoading(true);
		const file = event.target.files[0];
		var base64File = (await helper.convertFileToBase64(file)).split(",").at(1);

		political
			.addCsvMembers({
				politicalPartyID: selectedParty.politicalPartyID,
				fileData: base64File,
				title: file.name,
				membershipPeriodID: contestationPeriodID
			})
			.then((res) => {
				setLoading(false);
				if (res.success) {
					toast.show({
						severity: "success",
						detail: "Member List File Submitted",
						life: 2500
					});
					setRefresh(!refresh);
				} else {
					toast.show({
						severity: "error",
						detail: res.message,
						life: 2500
					});
				}
			});
	};

	const handleAddMemberManual = async (event) => {
		setLoading(true);
		political
			.addManualMembers({
				politicalPartyID: selectedParty.politicalPartyID,
				voterID: showAddDialog.voterRecord.voterID,
				membershipPeriodID: contestationPeriodID
			})
			.then((res) => {
				setLoading(false);
				if (res.success) {
					setShowAddDialog({ ...showAddDialog, show: false, voterRecord: null, idNumber: "" });
					setRefresh(!refresh);
					toast.show({
						severity: "success",
						detail: "Elector Added",
						life: 2500
					});
				} else {
					toast.show({
						severity: "error",
						detail: res.message,
						life: 2500
					});
				}
			});
	};

	const confirmDeleteMember = (e, row) => {
		console.log(row);
		confirmDialog({
			target: e.currentTarget,
			message: "Are you sure you want to proceed?",
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				setLoading(true);
				political.deletePartyMember(row).then((res) => {
					setLoading(false);
					if (res.success) {
						setRefresh(!refresh);
						toast.show({
							severity: "success",
							detail: "Member Removed",
							life: 2500
						});
					} else {
						toast.show({
							severity: "error",
							detail: res.message,
							life: 2500
						});
					}
				});
			},
			reject: () => { }
		});
	};

	return (
		<>
			<ConfirmDialog />
			<div className={!isDialog ? "flex flex-column md:flex-row md:justify-content-between md:align-items-center my-2" : ""}>
				{header !== null && <h5>{header}</h5>}
				<div className="flex">
					{!isOnlyView && (
						<>
							<div className="mr-2">
								<Button
									label="Upload CSV / Excel Spreadsheet"
									loading={loading}
									disabled={["", null, undefined].includes(contestationPeriodID)}
									onClick={() => {
										inputFileRef.current.value = null; // Clear the input value
										inputFileRef.current.click();
									}}
									className="p-button-success mr-3"
								/>
								<input
									ref={inputFileRef}
									type={"file"}
									multiple
									onChange={(e) => handleFileUpload(e)}
									style={{ display: "none" }}
									accept=".csv,.xlsx"
								></input>
							</div>
							<div>
								<Button
									disabled={["", null, undefined].includes(contestationPeriodID)}
									label="Add Member"
									loading={loading}
									onClick={() => {
										setShowAddDialog({ ...showAddDialog, show: true });
									}}
									className="p-button-success mr-3"
								/>
							</div>
						</>
					)}
				</div>
			</div>

			<Dialog
				header={
					<>
						<h5 className="my-0">Add Member </h5>
					</>
				}
				style={{ width: "100%", maxWidth: "800px" }}
				onHide={() => {
					setShowAddDialog({ ...showAddDialog, show: false, voterRecord: null, idNumber: "" });
				}}
				visible={showAddDialog.show}
				footer={
					<>
						{showAddDialog.voterRecord !== null && (
							<>
								<Button loading={loading} onClick={handleAddMemberManual} label="Submit" />
							</>
						)}

						<Button
							className="p-button-danger"
							onClick={() => setShowAddDialog({ ...showAddDialog, show: false, voterRecord: null, idNumber: "" })}
							label="Close"
						/>
					</>
				}
			>
				{/* <hr /> */}
				{/* <div className="col-12 f-bold">
					<b>Search by ID/Registration Number</b>
				</div> */}
				<div className="col-12">
					<MultiFilterSearch
						label={<>Search By <span style={{ color: "red" }}>*</span></>}
						onClear={() => {
							setShowAddDialog({ ...showAddDialog, voterRecord: null, idNumber: "" });
						}}
						onChange={res => {
							searchVoterByIDNumberFilter(res.idNumber)
							setShowAddDialog({ ...showAddDialog, idNumber: res.idNumber });

						}} />
				</div>

				{showAddDialog.voterRecord !== null && (
					<>
						<hr></hr>
						<div className="grid">
							<div className="col-12  md:col-6">
								<b>First Name</b>
							</div>
							<div className="col-12  md:col-6">
								<div className=" p-inputtext p-component p-filled">{showAddDialog.voterRecord.firstname}</div>
							</div>
							<div className="col-12  md:col-6">
								<b>Surname</b>
							</div>
							<div className="col-12  md:col-6 ">
								<div className=" p-inputtext p-component p-filled">{showAddDialog.voterRecord.surname}</div>
							</div>
							<div className="col-12  md:col-6">
								<b>Gender</b>
							</div>
							<div className="col-12  md:col-6 ">
								<div className=" p-inputtext p-component p-filled">{showAddDialog.voterRecord.gender}</div>
							</div>
							<div className="col-12  md:col-6">
								<b>Date Of Birth</b>
							</div>
							<div className="col-12  md:col-6 ">
								<div className=" p-inputtext p-component p-filled">{formatDate(showAddDialog.voterRecord.dateOfBirth)}</div>
							</div>
						</div>
					</>
				)}
			</Dialog>

			<TabView>
				<TabPanel header="Registered">
					<GenericDataTable
						key={refresh}
						call={getRegisteredMembers}
						size="small"
						scrollable={true}
						scrollHeight="400px"
						value={registerdMembers}
						dataKey="id"
						loading={loading}
						rowsPerPageOptions={[5, 10, 25]}
						className="datatable-responsive"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Members"
						emptyMessage="No members found."
						responsiveLayout="scroll"
						// selection={selectedMember}
						// onSelectionChange={(e) => setSelectedMember(e.value)}
						resizableColumns
						columnResizeMode="expand"
						// filters={filters}
						filterDisplay="Name"
						globalFilterFields={["Name"]}
					>
						<Column field="firstname" header="Name" sortable></Column>
						<Column field="surname" header="Surname" sortable></Column>
						{/* <Column field="idNumber" header="ID Number" sortable></Column> */}
						{isIecEdit && <Column  body={(e)=>maskMiddle(e.idNumber)} field="idNumber" header="ID Number" sortable></Column>}

						<Column field="registrationNumber" header="Registration Number" sortable></Column>

						<Column field="Created Date" header="Created Date" body={(e) => formatDateTime(e?.createdDate)} sortable></Column>
						<Column field="village.constituency" header={changeLang.get("national_delimitation.constituency")} sortable></Column>
						<Column field="village.registrationCentre" header={changeLang.get("national_delimitation.votingCentre")} sortable></Column>
						<Column field="village.name" header={changeLang.get("national_delimitation.village")} sortable></Column>
						<Column
							field="actions"
							header="Actions"
							body={(e) => (
								<>
									<Button
										disabled={isOnlyView}
										onClick={(ee) => confirmDeleteMember(ee, e)}
										style={{ textAlign: "center", width: "30px", height: "30px" }}
										icon={"pi pi-times"}
										className="p-button-danger p-button-rounded mr-2"
										tooltip="Click to delete"
									/>
								</>
							)}
						></Column>
					</GenericDataTable>
				</TabPanel>
				<TabPanel header="Failed Verification">
					<GenericDataTable
						call={getnonRegisteredMembers}
						size="small"
						scrollable={true}
						scrollHeight="400px"
						value={nonRegisterdMembers}
						loading={loading}
						rowsPerPageOptions={[5, 10, 25]}
						className="datatable-responsive"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Members"
						emptyMessage="No members found."
						responsiveLayout="scroll"
						// selection={selectedMember}
						// onSelectionChange={(e) => setSelectedMember(e.value)}
						resizableColumns
						columnResizeMode="expand"
						// filters={filters}
						filterDisplay="Name"
						globalFilterFields={["Name"]}
					>
						<Column field="firstName" header="Name" sortable></Column>
						<Column field="surname" header="Surname" sortable></Column>
						<Column field="registrationNumber" header="Registration Number" sortable></Column>
						{/* <Column field="idNumber" header="ID Number" sortable></Column> */}
						{isIecEdit && <Column body={(e)=>maskMiddle(e.idNumber)} field="idNumber" header="ID Number" sortable></Column>}
						<Column field="Created Date" header="Created Date" body={(e) => formatDateTime(e?.createdDate)} sortable></Column>
						<Column field="statusReason" header="Reason" sortable></Column>
					</GenericDataTable>
				</TabPanel>
			</TabView>
		</>
	);
}
